/* @flow */
import * as React from 'react';
import { css, names } from 'linaria';

import Colors from '../../constants/Colors';

class HamburgerIcon extends React.Component<{
  close?: boolean,
  color?: string,
  style: ?Object,
  className: ?string,
}> {
  static defaultProps = {
    color: Colors.IndigoLight,
  };

  render() {
    let { color, close, className, ...props } = this.props;

    return (
      <button className={names(Styles.Root, className)} {...props}>
        <div className={Styles.Inner}>
          <div
            className={Styles.Line}
            style={{
              backgroundColor: color,
              top: close ? '3px' : '0px',
              transform: close ? 'translateY(7px) rotate(-45deg)' : '',
            }}
          />
          <div
            className={Styles.Line}
            style={{
              backgroundColor: color,
              top: '10px',
              transform: close ? 'rotate(45deg)' : '',
            }}
          />
          <div
            className={Styles.Line}
            style={{
              backgroundColor: color,
              opacity: close ? 0 : 1,
              top: close ? '17px' : '20px',
            }}
          />
        </div>
      </button>
    );
  }
}
export default HamburgerIcon;

const Styles = {
  Root: css`
    background-color: transparent;
    border: none;
    outline: none;
    padding: 4px;
  `,
  Inner: css`
    height: 22px;
    position: relative;
    width: 30px;
  `,
  Line: css`
    height: 2px;
    left: 0;
    position: absolute;
    transition: all 0.2s ease;
    width: 30px;
  `,
};



// WEBPACK FOOTER //
// ./src/ui/components/chrome/HamburgerIcon.js